import { render, staticRenderFns } from "./Advertiser_Followers.vue?vue&type=template&id=ddd8b54a&scoped=true&"
import script from "./Advertiser_Followers.vue?vue&type=script&lang=js&"
export * from "./Advertiser_Followers.vue?vue&type=script&lang=js&"
import style0 from "./Advertiser_Followers.vue?vue&type=style&index=0&id=ddd8b54a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd8b54a",
  null
  
)

export default component.exports